// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'
import LabeledWrapper from './LabeledWrapper'
import AdditionalParameters from '../controls/AdditionalParameters'
import type { OptionType } from '../types'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 10px;
`

const SelectWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 250px;
`

type Props = {|
  showsPeriod: string,
  audienceShowsLimit: number,
  adShowsLimit: number,
  onChange: Function
|}

const t = {
  additional_parameters: 'Частота показов МТ',
  shows_period_label: 'Лимит показов уникальному пользователю',
  audience_shows_limit_label: 'На всю кампанию',
  ad_shows_limit_label: 'На каждое объявление',
  day: 'День',
  week: 'Неделя',
  month: 'Месяц',
  without_limit: 'Без ограничений'
}

export default class TargetMailShowsLimitInfo extends Component<Props> {
  render() {
    return (
      <Wrapper>
        <AdditionalParameters link={t.additional_parameters}>
          <LabeledWrapper label={t.shows_period_label} twoLines>
            <SelectWrapper className="t-TmShowsPeriodSelect">
              <Select
                value={this.props.showsPeriod}
                options={this.showsPeriodOptions()}
                onChange={(value) => this.props.onChange({ tmShowsPeriod: value })}
              />
            </SelectWrapper>
          </LabeledWrapper>
          <LabeledWrapper label={t.audience_shows_limit_label} twoLines>
            <SelectWrapper className="t-TmAudienceShowsLimitSelect">
              <Select
                value={this.props.audienceShowsLimit}
                options={this.numberLimitOptions()}
                onChange={(value) => this.props.onChange({ tmAudienceShowsLimit: value })}
              />
            </SelectWrapper>
          </LabeledWrapper>
          <LabeledWrapper label={t.ad_shows_limit_label} twoLines>
            <SelectWrapper className="t-TmAdShowsLimitSelect">
              <Select
                value={this.props.adShowsLimit}
                options={this.numberLimitOptions()}
                onChange={(value) => this.props.onChange({ tmAdShowsLimit: value })}
              />
            </SelectWrapper>
          </LabeledWrapper>
        </AdditionalParameters>
      </Wrapper>
    )
  }

  showsPeriodOptions(): Array<OptionType> {
    return [
      { id: 'day', name: t.day },
      { id: 'week', name: t.week },
      { id: 'month', name: t.month }
    ]
  }

  numberLimitOptions(): Array<OptionType> {
    return [
      { id: 0, name: t.without_limit },
      ..._.map(_.range(1, 32), (number) => {
        return { id: number, name: number.toString() }
      })
    ]
  }
}
